import { render, staticRenderFns } from "./ErrorHelpBlock.vue?vue&type=template&id=63049af6"
import script from "./ErrorHelpBlock.vue?vue&type=script&lang=js"
export * from "./ErrorHelpBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports